import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type {
  APIResponse,
  MatterStatuteOfLimitations,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

const matterStatutesOfLimitationsRoute = `${baseFastApiMatterRoute}/statute-of-limitations`;

type MatterStatuteOfLimitationsFastApiInput = Pick<
  MatterStatuteOfLimitations,
  "matterId"
> &
  Partial<Omit<MatterStatuteOfLimitations, "connections">>;

export type CreateMatterStatuteOfLimitationsV3Input =
  MatterStatuteOfLimitationsFastApiInput & {
    connections?: SourceOwnedConnectionCreate[];
  };

export const createMatterStatuteOfLimitationsV3 = (
  data: CreateMatterStatuteOfLimitationsV3Input,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterStatuteOfLimitations>
    >("matters/v4/statute-of-limitations", data)
    .then((res) => res.data);
};

export const updateMatterStatuteOfLimitationsV1 = (
  data: MatterStatuteOfLimitationsFastApiInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterStatuteOfLimitations>
    >(matterStatutesOfLimitationsRoute, data)
    .then((res) => res.data);
};

export const deleteMatterStatuteOfLimitationsV1 = (
  data: MatterStatuteOfLimitationsFastApiInput,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterStatuteOfLimitations>
    >(`${baseFastApiMatterRoute}/statute-of-limitations/${data.id}`)
    .then((res) => res.data);
};
